// components/PhotographySection.jsx
import React, { useState } from 'react';

const PhotographySection = () => {
  const [profileImage, setProfileImage] = useState(null);
  const [dragActive, setDragActive] = useState(false);

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => setProfileImage(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    
    if (e.dataTransfer.files && e.dataTransfer.files[0]) {
      const file = e.dataTransfer.files[0];
      const reader = new FileReader();
      reader.onload = (e) => setProfileImage(e.target.result);
      reader.readAsDataURL(file);
    }
  };

  return (
    <div className="space-y-6">
      <p className="text-gray-600">Gestiona tu foto de perfil</p>
      
      <div className="flex flex-col items-center space-y-4">
        <div className="w-32 h-32 rounded-full bg-gray-200 flex items-center justify-center overflow-hidden">
          {profileImage ? (
            <img src={profileImage} alt="Profile" className="w-full h-full object-cover" />
          ) : (
            <span className="text-gray-400 text-4xl">👤</span>
          )}
        </div>
        
        <div
          className={`w-full max-w-md p-6 border-2 border-dashed rounded-lg text-center transition-colors ${
            dragActive ? 'border-teal-500 bg-teal-50' : 'border-gray-300'
          }`}
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
        >
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className="hidden"
            id="image-upload"
          />
          <label htmlFor="image-upload" className="cursor-pointer">
            <div className="space-y-2">
              <div className="text-3xl">📸</div>
              <p className="text-gray-600">Arrastra una imagen aquí o haz clic para seleccionar</p>
              <p className="text-sm text-gray-400">PNG, JPG hasta 5MB</p>
            </div>
          </label>
        </div>
        
        <div className="flex space-x-3">
          <button className="px-4 py-2 bg-teal-500 text-white rounded-lg hover:bg-teal-600 transition-colors">
            Guardar imagen
          </button>
          <button className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300 transition-colors">
            Eliminar imagen
          </button>
        </div>
      </div>
    </div>
  );
};

export default PhotographySection;